module.exports = __webpack_public_path__ + "img/gomXchange.0a3ab783.png";